// @flow
import * as React from 'react';
import styled from 'styled-components';
import get from 'lodash/get';
import type { TCoachPlayerStatsById, TPlayersById  } from '../../../modules/types';
import { below } from '../../../assets/css/media';
import colors from '../../../assets/css/colors';
import {
	ButtonPrimary,
	LoadingSpinner,
	GameBarTimer,
	GameBarWrapper,
	DraftNotifications,
	CoachLockIcon
} from '../../../components/';
import {
	getTeamProjectedScore,
	getTeamScoreFromLadder,
	getTotalScoreFromLadder
} from '../../../helpers/team';
import { ordinalSuffixOf } from '../../../helpers';

const TeamGameBarData = styled.div`
	display: flex;
	align-items: center;
	justify-content: space-between;
	width: 40%;
	margin-left: 1em;
	> div {
		width: 105px;
		margin: 0 5px;
	}
	${below.tablet`
		width: auto;
		margin-left: 0;
	`}
`;

const RightItems = styled.div`
	margin-left: auto;
	display: flex;
`;

const TeamGameBarDataLabel = styled.div`
	font-size: 10px;
	letter-spacing: 0.5px;
	line-height: 1.4;
	text-align: center;
	color: ${colors.title};
	text-transform: uppercase;
	margin-bottom: 5px;
`;
const TeamGameBarDataValue = styled.div`
	font-size: 14px;
	font-weight: bold;
	line-height: 1.14285714;
	text-align: center;
	color: ${({ is_live }) => is_live? colors.liveGreen : colors.title};

`;
const TeamGameBarDataFC = styled.div`
	${TeamGameBarDataLabel} {
		color: ${colors.coachPurple};
	}
	${TeamGameBarDataValue} {
		color: ${colors.coachPurple};
	}
`;

const SaveBtn = styled(ButtonPrimary)`
	width: 115px;
	height: 36px;
	cursor: default;
	position: absolute;
	top: 50%;
	left: 50%;
	transform: translate(-50%, -50%);
	${below.tablet`
		height: 36px;
		width: 106px;
	`}
`;

type Props = {
	selected_team: Object,
	league: Object,
	selected_round: Object,
	is_team_saving: boolean,
	has_assistant_coach: boolean,
	coach_players_by_id?: TCoachPlayerStatsById,
	is_active_match: boolean,
	is_league_started: boolean,
	players_by_id: TPlayersById
}

export const TeamGameBar = (
	{
		selected_team,
		league,
		selected_round,
		is_team_saving,
		has_assistant_coach,
		coach_players_by_id,
		is_active_match,
		is_league_started,
		players_by_id
	}: Props
) => {
	const { id: round_id, status: round_status } = selected_round;
	const { start_round, team_id, id } = league;
	const { rank_history, lineup } = selected_team;
	const proj_score = has_assistant_coach && coach_players_by_id ? getTeamProjectedScore(
		lineup,
		players_by_id,
		coach_players_by_id,
		league,
		selected_round
	) : '--';
	const rank = ordinalSuffixOf(get(rank_history, round_id, '--'));
	let score = '--',
		total_score = '--';
	if (is_league_started) {
		score = getTeamScoreFromLadder(
			{ team: selected_team, is_active_match: true, round: selected_round, players_by_id }
		);
		total_score = getTotalScoreFromLadder(
			{ team: selected_team, start_round, round_id, is_active_match: true, score }
		);
	}

	return (
		<GameBarWrapper>
			<TeamGameBarData>
				<div>
					<TeamGameBarDataLabel>
						Score
					</TeamGameBarDataLabel>
					<TeamGameBarDataValue is_live={round_status === 'active'}>
						{score}
					</TeamGameBarDataValue>
				</div>
				<TeamGameBarDataFC className="hidden-mobile">
					<TeamGameBarDataLabel>
						PROJECTED SCORE
					</TeamGameBarDataLabel>
					<TeamGameBarDataValue>
						{has_assistant_coach ? proj_score : (
							<CoachLockIcon color={colors.darkGrey} size=".875" />
						)}
					</TeamGameBarDataValue>

				</TeamGameBarDataFC>
				<div className="hidden-mobile">
					<TeamGameBarDataLabel>
						Overall Score
					</TeamGameBarDataLabel>
					<TeamGameBarDataValue>
						{total_score}
					</TeamGameBarDataValue>
				</div>
				<div className="hidden-mobile">
					<TeamGameBarDataLabel>
						league rank
					</TeamGameBarDataLabel>
					<TeamGameBarDataValue>
						{rank}
					</TeamGameBarDataValue>
				</div>
			</TeamGameBarData>
			<SaveBtn>
				{is_team_saving ? (
					<LoadingSpinner
						color={colors.nrlGreen}
						width="60px"
						height="15px"
						margin="0 auto"
					/>
				) : 'SAVED'}
			</SaveBtn>
			<RightItems>
				{team_id ? <DraftNotifications team_id={team_id} id={id} /> : null}
				<GameBarTimer selected_round={selected_round} league={league} />
			</RightItems>
		</GameBarWrapper>
	);
};

export default TeamGameBar;


// WEBPACK FOOTER //
// ./src/pages/league/team/teamGameBar.js